import { agroApi } from "../../../../redux/api/api";
import { MTSEndpoints } from "./types"; 

export const mtsbyyearApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    
    
    getMtsByYear: builder.query<
      MTSEndpoints['getMtsByYear']['response'],
      MTSEndpoints['getMtsByYear']['request']
    >({
      query: (filter) => ({
        url: "/departments/mechanization/mts-register/analytical-data",
        method: "GET",
        params: filter,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetMtsByYearQuery} = mtsbyyearApi;
